import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepThreeExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepThreeExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.findWordsStepThreeExtraCollections.data
      .findWordsStepThreeExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.findWordsStepThreeExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
